import {z} from 'zod';
const section=z.object({accounts:z.array(z.object({name:z.string(),amount:z.number().finite()})),total:z.number().finite()});
export const profitLossSchema=z.object({
 income:z.object({sales:section,directIncome:section,indirectIncome:section,total:z.number().finite()}),
 expenditure:z.object({purchases:section,directExpenses:section,indirectExpenses:section,total:z.number().finite()}),
 grossProfit:z.number().finite(),netProfit:z.number().finite(),
});
export type ProfitLossData=z.infer<typeof profitLossSchema>;
